<template>
  <article>
    <PageMyApprovalReleaseMobile v-if="isMobileOrTablet"></PageMyApprovalReleaseMobile>
    <PageMyApprovalReleaseDesktop v-else></PageMyApprovalReleaseDesktop>
  </article>
</template>

<script>
import { mapGetters } from "vuex"
import PageMyApprovalReleaseDesktop from "@/views/approvalRelease/PageMyApprovalRelease_Desktop"
import PageMyApprovalReleaseMobile from "@/views/approvalRelease/PageMyApprovalRelease_Mobile"

export default {
  name: "PageMyApprovalRelease",
  components: {
    PageMyApprovalReleaseDesktop,
    PageMyApprovalReleaseMobile,
  },
  data() {
    return {}
  },
  methods: {
    ...mapGetters(["getSmallDevice"]),
  },
  computed: {
    isMobileOrTablet() {
      return this.getSmallDevice()
    },
  },
}
</script>
